export default "__VITE_ASSET__CMsymDPQ__"